import { useLocation } from "react-router-dom";

export const useIsFollowup = () => {
  const location = useLocation();
  const { pathname } = location;

  if (pathname.includes("followup")) {
    return true;
  }

  return false;
};
